import { _COLORS } from "../constants";

export const defaultExcelStyle = (additionalStyles) => {
  const styles = [
    {
      id: "month-header",
      interior: {
        color: _COLORS.headerAgGrid,
        pattern: "Solid",
      },
    },
    {
      id: "total-header-col",
      interior: {
        color: _COLORS.totalAgGrid,
        pattern: "Solid",
      },
      font: {
        bold: true,
      },
    },
    {
      id: "total-row",
      interior: {
        color: _COLORS.totalLabourRow,
        pattern: "Solid",
      },
      font: {
        bold: true,
      },
    },
    {
      id: "agg-row",
      interior: {
        color: _COLORS.groupTotalRow,
        pattern: "Solid",
      },
      font: {
        bold: true,
      },
    },
    {
      id: "discount-row",
      interior: {
        color: _COLORS.groupDiscount,
        pattern: "Solid",
      },
      font: {
        bold: true,
      },
    },
  ];

  if (additionalStyles) styles.push(...additionalStyles);

  return styles;
};
